import { render, staticRenderFns } from "./AccountSettingPassword.vue?vue&type=template&id=00625300&"
import script from "./AccountSettingPassword.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00625300')) {
      api.createRecord('00625300', component.options)
    } else {
      api.reload('00625300', component.options)
    }
    module.hot.accept("./AccountSettingPassword.vue?vue&type=template&id=00625300&", function () {
      api.rerender('00625300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingPassword.vue"
export default component.exports